import { useEffect, useState, useContext } from "react";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Nav, Tab } from 'react-bootstrap';

import Categories from "./Categories";
import Transactions from "./Transactions";
import ColumnHeader from "./ColumnHeader";
import EditDataView from './EditDataView';

import RefreshContext from "../RefreshContext";
import apiClient from "../lib/apiClient";
import TimeRangePicker from "./TimeRangePicker";


export default function DataView() {
  const { id } = useParams();
  const [dataView, setDataView] = useState(null);
  const location = useLocation().hash || "#cashflow";
  const navigate = useNavigate();
  const { refreshKey } = useContext(RefreshContext);


  useEffect(() => {
    if (id) {
      apiClient.get("/api/data_views/" + id)
        .then(({data}) => {
          document.title = data.name;
          setDataView(data);
        }).catch(console.error);
    }
  }, [id, refreshKey]);

  if (!id || !dataView) {
    return null;
  }

  return <div className="container mt-1 me-2">
    <Tab.Container activeKey={location} onSelect={(tab) => navigate(tab)}>
      <ColumnHeader title={dataView.name}>
        <div className="d-flex align-items-baseline">
          <TimeRangePicker/>
          <Nav variant="underline">
            <Nav.Item>
              <Nav.Link eventKey="#cashflow">Cashflow</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#transactions">Transactions</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#edit">Edit</Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </ColumnHeader>
      <Tab.Content>
        <Tab.Pane eventKey="#cashflow">
          <Categories dataViewId={id} />
        </Tab.Pane>
        <Tab.Pane eventKey="#transactions">
          <Transactions dataViewId={id} />
        </Tab.Pane>
        <Tab.Pane eventKey="#edit">
          <EditDataView dataView={dataView} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>

  </div>

}
